import * as React from 'react';

import { lockHeader } from '../utils/LockHeader';
import { getScrollbarWidth } from './ScrollbarHelpers';

interface ScrollLockProps {
    isLocked: boolean;
    bodyClassName?: string;
    removeScroll?: boolean;
}

export class ScrollLock extends React.Component<ScrollLockProps, { scrollPosition?: number }> {
    private readonly bodyClassNames: string[];
    static active = 0;
    static scrollPosition: number | undefined = undefined;
    private scrollbarWidth = 0;

    constructor(props: ScrollLockProps) {
        super(props);

        this.bodyClassNames = this.props.bodyClassName ? this.props.bodyClassName.split(' ') : [];
    }

    componentDidMount() {
        if (this.props.isLocked) {
            ScrollLock.active++;
            this.activate(window.pageYOffset);
        }

        this.scrollbarWidth = getScrollbarWidth();
    }

    componentWillUnmount() {
        if (this.props.isLocked) {
            ScrollLock.active--;
            this.deactivate();
        }
    }

    componentDidUpdate(prevProps: ScrollLockProps): void {
        const isLockedChanged = prevProps.isLocked !== this.props.isLocked;
        const isRemoveScrollChanged = prevProps.removeScroll !== this.props.removeScroll;

        if (isLockedChanged) {
            const scrollY = window.pageYOffset;

            if (this.props.isLocked) {
                ScrollLock.active++;
                this.activate(scrollY);
            } else if (ScrollLock.scrollPosition !== undefined) {
                ScrollLock.active--;
                this.deactivate();
            }

            ScrollLock.scrollPosition = scrollY;
        }

        if (isRemoveScrollChanged) {
            this.updateClassList();
        }
    }

    static isActive = () => {
        return ScrollLock.active > 0;
    };

    private updateClassList = () => {
        const body = document.body;

        if (ScrollLock.isActive() && body) {
            body.classList.remove(...this.bodyClassNames, 'ScrollLock', 'ScrollLock--WithoutScroll');
            body.style.paddingRight = '';

            body.classList.add(...this.bodyClassNames, this.props.removeScroll ? 'ScrollLock--WithoutScroll' : 'ScrollLock');
            this.props.removeScroll && (body.style.paddingRight = this.scrollbarWidth + 'px');
        }
    };

    private activate = (scrollY: number) => {
        const body = document.body;

        if (ScrollLock.isActive() && body) {
            ScrollLock.scrollPosition = scrollY;
            body.classList.add(...this.bodyClassNames, this.props.removeScroll ? 'ScrollLock--WithoutScroll' : 'ScrollLock');
            body.style.top = `-${scrollY}px`;
            lockHeader(true);
        }
    };

    private removeClassNames = () => {
        const body = document.body;

        body.classList.remove('ScrollLock');
        body.classList.remove('ScrollLock--WithoutScroll');
        for (const className of this.bodyClassNames) {
            body.classList.remove(className);
        }
    };

    private deactivate = () => {
        const body = document.body;

        if (!ScrollLock.isActive() && ScrollLock.scrollPosition !== undefined && body) {
            body.style.top = '0';
            body.style.paddingRight = '';
            body.removeAttribute('aria-hidden');
            this.removeClassNames();
            window.scrollTo(0, ScrollLock.scrollPosition);
            setTimeout(() => {
                lockHeader(false);
            }, 1);
        }
    };

    render() {
        return <></>;
    }
}
